// Import React and other necessary libraries
import './bootstrapConfig.js';      // does our env/tenant/CSS-var injection
import React from 'react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import axios from 'axios';
import App from './App';
import './index.css';


// FOR AUTHENTICATION, if this app ever needs it:
// axios.defaults.headers.common['Authorization'] =
//   `Bearer ${process.env.REACT_APP_FRONTEND_SERVICE_TOKEN}`;

// Pushgateway endpoint (replace with your actual server)
const PUSHGATEWAY_URL = `${process.env.REACT_APP_API_HOST}/metrics/job/frontend`;

// Set --vh CSS variable to fix mobile Safari toolbar issues
function setViewportHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// Update on resize/orientation change
window.addEventListener('resize', setViewportHeight);
window.addEventListener('orientationchange', setViewportHeight);

// Run once on load
setViewportHeight();

if (window.location.pathname === '/popout-player') {
  document.body.classList.add('popout');
}


// Function to push metrics to Pushgateway
async function pushMetric(metricName, value, labels = {}) {
  // Skip metrics in development (localhost) or if API_HOST is not configured
  if (!process.env.REACT_APP_API_HOST || process.env.REACT_APP_API_HOST.includes('localhost')) {
    console.log(`[DEV] Skipping metric: ${metricName} = ${value}`);
    return;
  }

  const labelsString = Object.entries(labels)
    .map(([key, val]) => `${key}="${val}"`)
    .join(",");
  const payload = labelsString
    ? `${metricName}{${labelsString}} ${value}\n`
    : `${metricName} ${value}\n`;

  try {
    await axios.post(PUSHGATEWAY_URL, payload, {
      headers: { "Content-Type": "text/plain" },
    });
    console.log(`Metric ${metricName} pushed successfully.`);
  } catch (error) {
    console.error(`Error pushing metric: ${error.message}`); //THIS IS LINE 27 from the error we are trying to resolve
  }
}

// Example usage: Push page load metric
pushMetric("frontend_page_load", 1, { page: window.location.pathname });

// Setup React rendering
// ✅ Wrap App rendering in a try/catch to log render failure
const root = createRoot(document.getElementById('root'));
try {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
} catch (e) {
  console.error("[Render Error] Failed to mount App:", e);
}
